<template>
  <div>
    <!--    头部信息-->
    <div class="block">
      <div class="top">
        <div class="top-title">代理推广者注册网站：<span>{{ info.registerUrl }}</span>
          <el-button size="small" class="el-button--warning" type="primary" v-clipboard:copy="info.registerUrl"
            v-clipboard:success="onCopy">复制</el-button>
        </div>
        <div class="top-text">
          说明：复制此链接给您的分销代理进行注册，注册成功后即与您绑定分佣关系。分销代理通过这个链接登录管理他的达人和查看数据。
        </div>
      </div>
      <div class="text">新注册代理默认分佣比例：<span class="color-blue color-blue__underline" @click="setRate">{{ info.commissionRate
      }}%</span></div>
    </div>
    <!--    表格-->
    <div class="block margin-top-20">
      <div class="search">
        <el-form :inline="true" ref="formRef" :model="form" class="search-form">
          <el-form-item label="" prop="name">
            <el-input v-model="form.name" placeholder="代理昵称"></el-input>
          </el-form-item>
          <el-form-item label="" prop="phone">
            <el-input v-model="form.phone" placeholder="手机号"></el-input>
          </el-form-item>
          <el-form-item label="注册时间" prop="time">
            <el-date-picker v-model="form.time" type="daterange" range-separator="-" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <!-- 操作按钮 -->
            <el-button type="warning" @click="onFormSearch">查询</el-button>
            <el-button type="warning" plain @click="onFormReset('formRef')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table :data="table.list" border stripe v-loading="table.loading">
          <el-table-column prop="name" align="center" label="代理信息">
            <template slot-scope="{ row }">
              <div class="table-title">{{ row.nickname }}</div>
              <div class="table-text">手机号:{{ row.mobile }}</div>
              <div class="table-text">注册时间:{{ row.registerTime }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="userDyCommissionRatio" align="center" label="结佣比例">
            <template slot-scope="{ row }">
              <settle-record :row="row" />
            </template>
          </el-table-column>
          <el-table-column prop="dyDarenNum" align="center" label="关联抖音达人数量">
            <template slot-scope="{ row }">
              <span class="color-blue color-blue__underline" @click="goTalentList(row.nickname)"
                v-if="row.dyDarenNum > 0">{{ row.dyDarenNum
                }}</span>
              <span v-else>{{ row.dyDarenNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="withdrawAmountStr" align="center" label="已提现金额"></el-table-column>
          <el-table-column prop="balanceStr" align="center" label="账户余额"></el-table-column>
          <el-table-column prop="operation" align="center" label="操作">
            <template slot-scope="{ row }">
              <set-proxy-commission-rate :row="row" @getList="getList"></set-proxy-commission-rate>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页-->
      <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
        @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
        :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total" />
      <!--      设置默认分佣比例-->
      <set-default-commission-rate ref="SetDefaultCommissionRateRef" @getInfo="getInfo"></set-default-commission-rate>
    </div>
  </div>
</template>

<script>
import douYin from "@/javaApi/douyin";

const DouYinModel = new douYin();
import setProxyCommissionRate from "./SetProxyCommissionRate";
import settleRecord from "./SettleRecord";
import SetDefaultCommissionRate from "./SetDefaultCommissionRate";
export default {
  name: "proxyList",
  components: {
    setProxyCommissionRate,
    settleRecord,
    SetDefaultCommissionRate
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        time: [],
        registerEndTime: '',
        registerStartTime: ''
      },
      table: {
        total: 0,
        list: [],
        loading: false,
      },
      pagination: {
        pageNo: 1,
        pageSize: 10
      },
      info: {}
    }
  },

  mounted() {
    this.getList()
    this.getInfo()
  },
  methods: {
    // 表单搜素
    onFormSearch() {
      this.pagination.pageNo = 1;
      if (this.form.time && this.form.time.length) {
        this.form.registerStartTime = this.form.time[0];
        this.form.registerEndTime = this.form.time[1];
      } else {
        this.form.registerStartTime = '';
        this.form.registerEndTime = '';
      }
      this.getList();
    },
    // 表单重置`
    onFormReset(form) {
      this.$refs[form].resetFields();
      this.form.time = [];
      this.pagination.pageSize = 10;
      this.onFormSearch();
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    // 分页跳转
    onCurrentChange() {
      this.getList();
    },
    async getList() {
      this.table.loading = true;
      const params = {
        nickname: this.form.name,
        mobile: this.form.phone,
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
        registerEndTime: this.form.registerEndTime,
        registerStartTime: this.form.registerStartTime,
      }
      const data = await DouYinModel.getAgentList(params).finally(() => {
        this.table.loading = false;
      });
      let res = data.data
      if (res.code === 200) {
        this.table.list = res.data.list;
        this.table.total = res.data.total;
      }
    },
    // 获取代理注册信息
    async getInfo() {
      const data = await DouYinModel.getAgentRegister()
      let res = data.data
      if (res.code === 200) {
        this.info = res.data
      }
    },
    //复制
    onCopy: function (e) {
      this.$Message.success('复制成功');
    },
    onError: function (e) {
      this.$Message.success('复制失败');
    },
    //跳转达人列表
    goTalentList(name) {
      this.$router.push({
        name: 'douyinMasterList',
        params: {
          agentName: name,
        },
      })
    },
    setRate() {
      this.$refs.SetDefaultCommissionRateRef.onOpenDialog()
    }
  }
}
</script>

<style scoped lang="less">
.top {
  display: flex;
  align-items: center;

  &-title {
    width: 50%;
    font-size: 16px;
    color: #333333;
    font-weight: 600;
    margin-right: 20px;

    span {
      color: #3D9EFC;
      font-size: 12px;
    }
  }

  &-text {
    font-size: 12px;
    color: red;
    margin-left: 10px;
  }
}

.margin-top-20 {
  margin-top: 20px;
}

.text {
  margin-top: 20px;
  font-size: 13px;

  span {
    color: #3D9EFC;
  }
}

.table-title {
  font-size: 14px;
  color: #333333;
  font-weight: 600;
}

.table-text {
  font-size: 12px;
  color: #999999;
}

.span {
  color: #3D9EFC;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/proxyList/index.vue